import { UserAddress } from "../../../../shared/models/user/user-address";
import { WarehouseModel } from "../../../../shared/models/order/warehouse.model";
import { GapContainer } from "../../../../components/card/styled";
import BarekamText from "../../../../components/text";
import BarekamChip from "../../../../components/chip/barekamChip";
import { Message, MessageSections } from "../../../../components/message/message";
import { ThreeDot } from "../../../../components/three-dot/three-dot";
import { MenuItem } from "@mui/material";
import { SingleSelectItem } from "../../../../components/single-select-item/single-select-item";
import React from "react";
import { User } from "../../../../shared/models/user/user";
import { useAppSelector } from "../../../../../redux/store";

export const SingleAddress = ({ address, warehouse, user, setAddressToDelete, onAddressEdit, isReadonly }: SingleAddressProps) => {
    const { languageId } = useAppSelector(state => state.messagesReducer);

    let topLabel: any = undefined;
    let lowerLabel: any = undefined;
    let rightLabel: any = undefined;
    let key = '';

    function getLowerLabel(userAddress: UserAddress) {
        return [
            userAddress.country?.name[languageId] || '',
            userAddress.city?.name[languageId] || '',
            userAddress.province?.name[languageId] || '',
            userAddress.region?.name[languageId] || '',
            userAddress.street,
            userAddress.building,
            userAddress.entrance,
            userAddress.floor,
            userAddress.apartment]
            .filter(value => !!value)
            .join(', ');
    }

    if (address) {
        topLabel = (
            <GapContainer>
                <BarekamText variant={'m'} bold>
                    {address.name || <Message messageKey={'address'} sectionId={MessageSections.USER} />}
                </BarekamText>

                {address.isDefault
                    ? <BarekamChip
                        messageKey={'default_address'}
                        messageSection={MessageSections.USER}
                        statusId={3}
                        chipSize={'s'} />
                    : ''
                }
            </GapContainer>
        );

        lowerLabel = (
            <BarekamText variant={'s'} opaque>
                {getLowerLabel(address)}
            </BarekamText>
        )

        rightLabel = (isReadonly
            ? ''
            : <ThreeDot>
                <MenuItem onClick={() => setAddressToDelete && setAddressToDelete(address)}>
                    <Message messageKey={'delete'} sectionId={MessageSections.USER} />
                </MenuItem>
            </ThreeDot>
        )

        key = 'address-' + address.addressId;
    } else if (warehouse) {
        topLabel = (
            <GapContainer>
                <BarekamText variant={'m'} bold>
                    <Message messageKey={warehouse.city} sectionId={MessageSections.MAIN} />
                </BarekamText>

                {user && user.defaultDeliveryWarehouseId === warehouse.warehouseId
                    ? <BarekamChip
                        messageKey={'default_address'}
                        messageSection={MessageSections.USER}
                        statusId={3}
                        chipSize={'s'} />
                    : ''
                }
            </GapContainer>
        );

        lowerLabel = (
            <BarekamText variant={'s'} opaque>
                {warehouse.addressLine1}
            </BarekamText>
        )

        key = 'warehouse-' + warehouse.warehouseId;
    }


    return (
        <SingleSelectItem TopLabel={topLabel}
            LowerLabel={lowerLabel}
            RightLabel={rightLabel}
            selected={false}
            onClick={() => address && onAddressEdit && onAddressEdit(address)}
            key={key} />
    );
}

interface SingleAddressProps {
    address?: UserAddress,
    warehouse?: WarehouseModel,
    user?: User,
    isReadonly?: boolean,

    setAddressToDelete?: (address: UserAddress) => void,
    onAddressEdit?: (address: UserAddress) => void,
}